import { BaseClient } from '../base-client';
import type { ChartOfAccount } from './types';

type ListResponse = { data: ChartOfAccount[]; meta: { total: number } };

/** The chart of accounts — read-only, and small enough to take whole. */
export class ChartOfAccountsClient extends BaseClient {
  list(): Promise<ListResponse> {
    return this.request('/api/chart-of-accounts');
  }
}
